import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import BackArrow from '../Icons/BackArrow';
import routeMap from '../../config/routeMap';
import progress from '../../config/progress';
import menu from '../../config/menu';
import { IconLearning, IconRecycling, IconStart } from '../SVG/Navbar';
import Arrow from '../SVG/Arrow';
import ActiveArrow from '../SVG/ActiveArrow';
import Badge1 from '../SVG/Badge1';
import Badge2 from '../SVG/Badge2';
import Badge3 from '../SVG/Badge3';
import Badge4 from '../SVG/Badge4';
import Badge5 from '../SVG/Badge5';
import Lock from '../SVG/Lock';

import style from './Navbar.module.scss';

class Navbar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isMenuOpen: false,
      showSubcategory: false,
      learnig: false,
      badge: [Badge1],
      category: ['Nauka jazdy', 'Prawo jazdy', 'Początkujący programista', 'Programista amator', 'Robotyk']
    };
    this.showSubcategory = this.showSubcategory.bind(this);
  }

  static propTypes = {
    backButtonVisible: PropTypes.bool,
    theme: PropTypes.string
  };

  static defaultProps = {
    backButtonVisible: true,
  };

  toggleMenu = () => {
    this.setState(prevState => ({
      isMenuOpen: !prevState.isMenuOpen
    }))
  };

  historyGoBack = () => {
    this.props.history.goBack();
  };

  componentDidMount() {
    const progress = JSON.parse(localStorage.getItem("progress"));
    this.setState({progress});
  }

  showSubcategory(id) {
    this.setState({[id]: !this.state[id]});
  }

  render() {
    const { backButtonVisible, theme } = this.props;
    const Progress = progress[this.props.location.pathname];
    const isMobile = (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent));
    const mainMenuClasses = classNames(style.navbarMainMenu, { [style.isActive]: this.state.isMenuOpen });
    const triggerClasses = classNames(style.menuTrigger,
      {
        [style.isActive]: this.state.isMenuOpen,
        [style.isWhite]: (theme === 'Blue') || (theme === 'Green')
      });

    return (
      <div style={!isMobile ? {marginTop: "10px", marginBottom: "20px"} : {}} className={style.navbarWrapper}>
        {backButtonVisible && (
          <div onClick={this.historyGoBack}>
            <BackArrow theme={this.props.theme} />
          </div>
        )}
        {progress[this.props.location.pathname] && <Progress width="100%" height={isMobile ? "28px" : "45px"} className={style.MenuItemIcon} /> }
        <button
          className={triggerClasses}
          onClick={this.toggleMenu}
        >
          <span className={style.MenuIcon} />
          <span className={style.MenuIcon} />
          <span className={style.MenuIcon} />
        </button>

        <ul className={mainMenuClasses}>
          <li className={style.mainMenuItem}>
            <IconStart className={style.MenuItemIcon} />
            <Link to={routeMap.home}>Start</Link>
          </li>
          <li className={style.mainMenuItem}>
            <IconRecycling className={style.MenuItemIcon} />
            <Link to={routeMap.recycling}>Recykling</Link>
          </li>
          <li className={style.mainMenuItem} onClick={()=>this.showSubcategory("showSubcategory")}>

              <IconLearning className={style.MenuItemIcon} />
              <span className={this.state.showSubcategory ? style.ActiveArrow : ""}>Nauka programowania {this.state.showSubcategory ? <ActiveArrow className={style.MenuItemIcon} /> : <Arrow className={style.MenuItemIcon} />  } </span>
          </li>
          {this.state.showSubcategory &&
          <span>
          {menu.map((el, id) =>
          <span key={id}>
            <li className={style.mainMenuItem}>
              <a style={{display: 'flex'}}>
                {(Object.keys(el).every((e)=> this.state.progress.includes(routeMap[`${e}`]))) ?
                <span>
                { id === 0 && <Badge1 height={'20px'}/> }
                { id === 1 && <Badge2 height={'20px'}/> }
                { id === 2 && <Badge3 height={'20px'}/> }
                { id === 3 && <Badge4 height={'20px'}/> }
                { id === 4 && <Badge5 height={'20px'}/> }
                </span>
               : <span>{(Object.keys(el).some((e)=> this.state.progress.includes(routeMap[`${e}`]))) ? <span style={{marginLeft: '20px'}} /> : <Lock height={'20px'} viewBox={'0 0 10 10'} className={style.MenuItemIcon} /> }
                </span>
              }
              { (Object.keys(el).some((e)=> this.state.progress.includes(routeMap[`${e}`]))) ?
                <span onClick={()=>this.showSubcategory(this.state.category[id])} className={this.state[this.state.category[id]] ? style.ActiveArrow : ""} style={{marginLeft: '1rem'}}> { this.state.category[id] } {this.state[this.state.category[id]] ? <ActiveArrow className={style.MenuItemIcon} /> : <Arrow className={style.MenuItemIcon} />  } </span>
                :
                <span style={{marginLeft: '1rem'}}> { this.state.category[id] }</span>
              }
              </a>
            </li>
            {this.state[this.state.category[id]] &&
              <span>
              {Object.keys(el).map((key)=>
                <li key={key} className={style.mainMenuItem}>
                  {this.state.progress.includes(routeMap[`${key}`]) ? <Link style={{marginLeft: '3rem'}} to={routeMap[`${key}`]}>{el[`${key}`][0].toUpperCase() + el[`${key}`].slice(1)}</Link> : (<span style={{marginLeft: '13px'}}><Lock className={style.MenuItemIcon} /><span><span style={{marginLeft: "1rem"}}>{el[`${key}`][0].toUpperCase() + el[`${key}`].slice(1)}</span></span></span>)}
                </li>
              )}
              </span>
            }
            </span>
          )}
          </span>
          }
        </ul>
      </div>
    );
  }
}

export default withRouter(Navbar);



// WEBPACK FOOTER //
// ./src/components/Navbar/index.js